import React from 'react'
import SocialIcons from './SocialIcons'
import ymResume from '../../src/YM-final-resume-2024.pdf'

const AboutMeLeftContent = () => {
    return (
        <div style={{ height: "100%", width: "100%" }} className="card text-bg-dark">
            <img src="https://e0.pxfuel.com/wallpapers/534/655/desktop-wallpaper-ultra-matte-black-background-warnerwave-xyz-thumbnail.jpg" className="card-img" alt="bg-image-about" />
            <div className="">
                <div
                    style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 3, textAlign: "center" }}
                >
                    <div>
                        <img src="https://avatars.githubusercontent.com/u/59337853?s=400&u=79b3ab36f0076a3a6cfbf481c2d42dccf511bdc7&v=4" style={{ width: "100px", height: "100px", borderRadius: "100%", border: "5px solid white" }} alt="Profile Avatar" />
                    </div>
                    <div style={{ position: "relative", top: "20px" }}>
                        <h6 className="card-title text-light">Yash Marmat</h6>
                        <p className="card-text text-light" style={{ width: "max-content", fontSize: "12.5px" }}>Python Fullstack Developer</p>
                        <SocialIcons />
                    </div>
                </div>
            </div>

            <div className='p-2' style={{ position: 'absolute', bottom: 0, display: "flex", justifyContent: "center", backgroundColor: "black", width: "100%" }}>
                <a
                    style={{ textDecoration: "none", color: "inherit" }}
                    href={ymResume}
                    download="Yash_Marmat_Resume.pdf"
                >
                    <span style={{ fontSize: "13px"}}>Donwload CV</span> <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-download" viewBox="0 0 16 16">
                        <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                        <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
                    </svg>
                </a>
            </div>
        </div>
    )
}

export default AboutMeLeftContent